import Type from "@/model/types/Type";

const type = {
    EXECUTION_PARALLEL: 4,
/*    RETURN_STEP_ORIGIN: 1,
    RETURN_NEXT_STEP_ORIGIN: 2,NÃO IMPLEMENTADOS NO BACK-END*/
    RETURN_SPECIFIC_STEP: 3,
    DELEGATE_RULES: 5,
    FINAL_INSPECTION_SHIPPING: 6,
}
const list = [
    {
        value: type.EXECUTION_PARALLEL,
        text: "Etapa em paralelo",
    },
    /*{
        NÃO IMPLEMENTADOS NO BACK-END
        value: type.RETURN_STEP_ORIGIN,
        text: "Retornar para mesma etapa de origem",
    },
    {
        value: type.RETURN_NEXT_STEP_ORIGIN,
        text: "Retornar para próxima etapa em relação a origem",
    },*/
    {
        value: type.RETURN_SPECIFIC_STEP,
        text: "Retornar para etapa específica",
    },
    {
        value: type.DELEGATE_RULES,
        text: "Definir posteriormente pelas regras",
    },
    {
        value: type.FINAL_INSPECTION_SHIPPING,
        text: "Inspeção Final para Expedição",
    },
]
const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

export default {
    type,
    list,
    contains,
}